import { Head } from '@/components/seo';

type ContentLayoutProps = {
  children: React.ReactNode;
  title: string;
  description?: string;
};

export const ContentLayout = ({
  children,
  title,
  description,
}: ContentLayoutProps) => {
  return (
    <>
      <Head title={title} description={description} />
      <div className="mx-auto px-4 py-4 pb-24 sm:px-6 md:px-8 md:py-6">
        {children}
      </div>
    </>
  );
};
